import React, { Suspense } from "react";
import { Form, Col } from "react-bootstrap";
import { Typeahead } from "react-bootstrap-typeahead";
import { Await, useLoaderData, useRouteLoaderData } from "react-router-dom";

export default function CollectionsPicker({
    formData,
    setFormData,
    name,
    colXl = 3,
    filterFunction = () => true,
    disabled,
    allowNew = false,
    includeRadioName = true,
}) {
    const { radios } = useRouteLoaderData("root");
    const { freestyleDeltas } = useLoaderData();

    return (
        <Suspense fallback={<Fallback name={name} colXl={colXl} />}>
            <Await resolve={radios}>
                {resolvedRadios => (
                    <Await resolve={freestyleDeltas}>
                        {resolvedCollections => (
                            <Form.Group as={Col} className={`col-12 col-xl-${colXl} min-w-collection`}>
                                <Form.Label>Collection</Form.Label>
                                <Typeahead
                                    id={`${name}-colection-selection`}
                                    options={resolvedCollections.data.filter(filterFunction)}
                                    labelKey={
                                        includeRadioName
                                            ? option =>
                                                  `${option.collection_name} | ${resolvedRadios.data.find(x => x.radio_id === option.radio_id)?.radio_name}`
                                            : "collection_name"
                                    }
                                    highlightOnlyResult={!allowNew}
                                    placeholder={`Select ${allowNew && "or create "}collection...`}
                                    newSelectionPrefix="New collection: "
                                    emptyLabel={`No collections. ${allowNew && "Type name to create new"}`}
                                    allowNew={allowNew}
                                    clearButton={true}
                                    paginate={false}
                                    maxResults={0}
                                    onChange={value => setFormData({ ...formData, collection: value })}
                                    selected={formData.collection}
                                    disabled={disabled}
                                />
                            </Form.Group>
                        )}
                    </Await>
                )}
            </Await>
        </Suspense>
    );
}

function Fallback({ name, colXl }) {
    return (
        <Form.Group as={Col} className={`col-12 col-xl-${colXl} min-w-collection`}>
            <Form.Label>Collection</Form.Label>
            <Typeahead id={`${name}-colection-selection-fallback`} options={[]} placeholder="Loading collections..." disabled />
        </Form.Group>
    );
}
